import { type FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import CardGridWrapper from 'src/components/CardGridWrapper';
import { ShoppingList } from 'src/types/view_shopping_lists/ShoppingList';
import { useContextSelector } from 'use-context-selector';
import ShoppingListCard from './ShoppingListCard';
import { ViewShoppingListsContext } from './ViewShoppingListsContext';
import ViewShoppingListsGridHeader from './ViewShoppingListsGridHeader';
import ViewShoppingListsSelectAll from './ViewShoppingListsSelectAll';

const ViewShoppingListsGridView: FC = () => {
  const { t } = useTranslation();
  const shoppingLists = useContextSelector(ViewShoppingListsContext, (s) => s.shoppingLists);
  const isLoading = useContextSelector(ViewShoppingListsContext, (s) => s.isLoading);
  const searchValue = useContextSelector(ViewShoppingListsContext, (s) => s.searchValue);
  const hasSearchValue = Boolean(searchValue && searchValue.trim());

  const renderCard = useCallback(
    (shoppingList: ShoppingList) => (
      <ShoppingListCard key={shoppingList.id} shoppingList={shoppingList} />
    ),
    []
  );

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex min-h-0 flex-1 flex-col px-4 pb-4">
        {hasSearchValue && (
          <div className="mb-2 shrink-0 truncate text-sm font-[600]">
            {t('Showing results for')} &quot;{searchValue.trim()}&quot;
          </div>
        )}
        <CardGridWrapper<ShoppingList>
          dataSource={shoppingLists}
          renderItem={renderCard}
          total={shoppingLists.length}
          pageable={false}
          loading={isLoading}
          className="min-h-0 flex-1"
          tableTextId="Lists"
          height="100%"
          gridClassName="grid grid-cols-1 min-[480px]:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2"
          headerChildren={<ViewShoppingListsGridHeader />}
          subHeaderChildren={<ViewShoppingListsSelectAll />}
          noRecordText={t('No Shopping List Found')}
        />
      </div>
    </div>
  );
};

export default ViewShoppingListsGridView;
